/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlbumResponse } from '../../models/album-response';

export interface AlbumsControllerFindOneBySlug$Params {
  slug: string;
}

export function albumsControllerFindOneBySlug(http: HttpClient, rootUrl: string, params: AlbumsControllerFindOneBySlug$Params, context?: HttpContext): Observable<StrictHttpResponse<AlbumResponse>> {
  const rb = new RequestBuilder(rootUrl, albumsControllerFindOneBySlug.PATH, 'get');
  if (params) {
    rb.path('slug', params.slug, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AlbumResponse>;
    })
  );
}

albumsControllerFindOneBySlug.PATH = '/albums/by-slug/{slug}';
